var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"type1Refs",attrs:{"id":"type1"}},[_vm._v("1")]),_c('div',{ref:"type2Refs",attrs:{"id":"type2"}},[_vm._v("2")])])
}
var staticRenderFns = []

export { render, staticRenderFns }